import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import TaskManagerOverview from "./TaskManagerOverview"

const TaskManager = () => {
  return (
    <SidePanelLayout
      menuName="AdminTaskManager"
      tabs={{
        tasks: TaskManagerOverview,
      }}
    />
  )
}

export default TaskManager
